var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-simple-layout',[[_vm._v(" 404 ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }